import React from "react";
import {useTranslation} from "react-i18next";

export default function VariableBlock({ item, state, updateState }) {

    const {t} = useTranslation();

    return (
        <div>
            <div className="mb-6">
                <label className="block mb-2 font-medium text-gray-900">{ t('name') }:</label>
                <input type="text" value={state.variables.name} name="name" onChange={updateState} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-0 focus:border-main"/>
            </div>
        </div>
    );
}
